import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

import { PageState } from "./util";
import { baseDate } from "@/libs/util";
import { AssetView } from "@/libs/assetUtil";
import { AssetManagementModule } from "./assetManagement";
import {
  MenuCardItem,
  MenuTabItem,
  card,
  tab,
  mergeSecurityMenu,
} from "@/libs/menuUtil";
import { AuthModule } from "@/store/modules/auth";

@Module({ dynamic: true, store, name: "netFinder.Common", namespaced: true })
export class Common extends VuexModule {
  networkPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };

  assetPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };

  mainView: AssetView = {
    name: "管理台帳",
    shown: {
      basics: AssetManagementModule.defaultBasics.slice(),
      additionals: AssetManagementModule.defaultAdditionals.slice(),
    },
    filters: [],
  };

  teleworkManagerPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };

  sessionListPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };

  // VLB
  nodeConfigPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };

  // membership
  employeeInfoListPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };
  // 確定された入力内容
  employeeInfoListName: string = "";
  employeeInfoListDepartment: string = "";
  // UIと連動しているモデル
  employeeInfoListNameModel: string | null = "";
  employeeInfoListDepartmentModel: string | null = "";

  @Action({ rawError: true })
  InitEmployeeInfoList() {
    this.employeeInfoListPageState.curPage = 1;
    this.employeeInfoListPageState.sortBy = null;
    this.employeeInfoListPageState.descending = null;
    this.InitEmployeeInfoListModel(true);
  }

  @Mutation
  InitEmployeeInfoListModel(force: boolean) {
    if (force) {
      this.employeeInfoListName = "";
      this.employeeInfoListDepartment = "";
    }
    this.employeeInfoListNameModel = this.employeeInfoListName;
    this.employeeInfoListDepartmentModel = this.employeeInfoListDepartment;
  }

  @Mutation
  SetEmployeeInfoListName(name: string) {
    this.employeeInfoListName = name;
  }

  @Mutation
  SetEmployeeInfoListDepartment(department: string) {
    this.employeeInfoListDepartment = department;
  }

  @Mutation
  SetEmployeeInfoListNameModel(name: string | null) {
    this.employeeInfoListNameModel = name;
  }

  @Mutation
  SetEmployeeInfoListDepartmentModel(department: string | null) {
    this.employeeInfoListDepartmentModel = department;
  }

  @Mutation
  SyncEmployeeInfoListModel() {
    this.employeeInfoListName =
      this.employeeInfoListNameModel == null
        ? ""
        : this.employeeInfoListNameModel;
    this.employeeInfoListDepartment =
      this.employeeInfoListDepartmentModel == null
        ? ""
        : this.employeeInfoListDepartmentModel;
  }

  // Vario SSO
  ssoUserListPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };

  @Action({ rawError: true })
  InitVtmHome() {
    this.InitHomeVtmTargetDate(true);
    this.homeVtmPageState.curPage = 1;
    this.InitHomeVtmModel(true);
  }

  homeVtmPageState: PageState = {
    curPage: 1,
    sortBy: null,
    descending: null,
  };

  homeVtmTargetDate: string = "";
  homeVtmGraphTargetDate: string = "";

  // 確定された入力内容
  homeVtmName: string = "";
  homeVtmDepartment: string = "";
  // UIと連動しているモデル
  homeVtmNameModel: string | null = "";
  homeVtmDepartmentModel: string | null = "";

  @Mutation
  InitHomeVtmTargetDate(force: boolean) {
    if (force || this.homeVtmTargetDate == "") {
      const today = baseDate();
      this.homeVtmTargetDate =
        today.slice(0, 4) + "-" + today.slice(4, 6) + "-" + today.slice(6);
    }
    this.homeVtmGraphTargetDate = this.homeVtmTargetDate + "." + Date.now();
  }

  @Mutation
  InitHomeVtmModel(force: boolean) {
    if (force) {
      this.homeVtmName = "";
      this.homeVtmDepartment = "";
    }
    this.homeVtmNameModel = this.homeVtmName;
    this.homeVtmDepartmentModel = this.homeVtmDepartment;
  }

  @Mutation
  SetHomeVtmTargetDate(targetDate: string) {
    this.homeVtmTargetDate = targetDate;
  }

  @Mutation
  SyncHomeVtmGraphTargetDate() {
    if (this.homeVtmTargetDate != "") {
      this.homeVtmGraphTargetDate = this.homeVtmTargetDate + "." + Date.now();
    }
  }

  @Mutation
  UpdateHomeVtmGraphTargetDate() {
    if (this.homeVtmGraphTargetDate != "") {
      const tokens = this.homeVtmGraphTargetDate.split(".");
      if (tokens.length == 2) {
        this.homeVtmGraphTargetDate = tokens[0] + "." + Date.now();
      }
    }
  }

  @Mutation
  SyncHomeVtmModel() {
    this.homeVtmName =
      this.homeVtmNameModel == null ? "" : this.homeVtmNameModel;
    this.homeVtmDepartment =
      this.homeVtmDepartmentModel == null ? "" : this.homeVtmDepartmentModel;
  }

  @Mutation
  SetHomeVtmName(name: string) {
    this.homeVtmName = name;
  }

  @Mutation
  SetHomeVtmDepartment(department: string) {
    this.homeVtmDepartment = department;
  }

  @Mutation
  SetHomeVtmNameModel(name: string | null) {
    this.homeVtmNameModel = name;
  }

  @Mutation
  SetHomeVtmDepartmentModel(department: string | null) {
    this.homeVtmDepartmentModel = department;
  }

  @Mutation
  InitMainView() {
    this.mainView.shown.basics = AssetManagementModule.defaultBasics.slice();
    this.mainView.shown.additionals =
      AssetManagementModule.defaultAdditionals.slice();
  }

  menuInfo: {
    cardsVnss: MenuCardItem[];
    cardsOthers: MenuCardItem[];
    cardsSso: MenuCardItem[];
    tabs: MenuTabItem[];
    vnssAvailable: boolean;
    ssoAvailable: boolean;
  } = {
    cardsVnss: [],
    cardsOthers: [],
    cardsSso: [],
    tabs: [],
    vnssAvailable: false,
    ssoAvailable: false,
  };

  @Action({ rawError: true })
  InitMenuInfo() {
    const cardsVnss: MenuCardItem[] = [];
    const cardsOthers: MenuCardItem[] = [];
    const cardsSso: MenuCardItem[] = [];
    const tabs: MenuTabItem[] = [];
    let vnssAvailable = false;

    const board = AuthModule.currentBoard;
    if (!board) {
      return;
    }
    const menus = board.data.menus;
    const admin = AuthModule.isSuperAdminUser;
    // Home
    const tabHome = tab({ service: "home", active: true }, admin);
    if (tabHome) {
      tabs.push(tabHome);
    }
    // security
    const security = menus.find((menu) => menu.service === "security");
    const sase = menus.find((menu) => menu.service === "sase");
    const menu = mergeSecurityMenu(security, sase);
    const cardSecurity = card(menu, admin);
    const tabSecurity = tab(menu, admin);
    if (cardSecurity) {
      cardsOthers.push(cardSecurity);
    }
    if (tabSecurity) {
      tabs.push(tabSecurity);
    }
    // dataAnalyzer
    const dataAnalyzer = menus.find((menu) => menu.service === "dataAnalyzer");
    const cardDataAnalyzer = card(dataAnalyzer, admin);
    const tabDataAnalyzer = tab(dataAnalyzer, admin);
    if (cardDataAnalyzer) {
      cardsOthers.push(cardDataAnalyzer);
    }
    if (tabDataAnalyzer) {
      tabs.push(tabDataAnalyzer);
    }
    // dataProtect
    const dataProtect = menus.find((menu) => menu.service === "dataProtect");
    const cardDataProtect = card(dataProtect, admin);
    const tabDataProtect = tab(dataProtect, admin);
    if (cardDataProtect) {
      cardsOthers.push(cardDataProtect);
    }
    if (tabDataProtect) {
      tabs.push(tabDataProtect);
    }
    // netFinder
    const netFinder = menus.find((menu) => menu.service === "netFinder");
    const cardNetFinder = card(netFinder, admin);
    const tabNetFinder = tab(netFinder, admin);
    if (cardNetFinder) {
      cardsVnss.push(cardNetFinder);
      vnssAvailable = vnssAvailable || cardNetFinder.active;
    }
    if (tabNetFinder) {
      tabs.push(tabNetFinder);
    }
    // vulnTracker
    const vulnTracker = menus.find((menu) => menu.service === "vulnTracker");
    const cardVulnTracker = card(vulnTracker, admin);
    const tabVulnTracker = tab(vulnTracker, admin);
    if (cardVulnTracker) {
      cardsVnss.push(cardVulnTracker);
      vnssAvailable = vnssAvailable || cardVulnTracker.active;
    }
    if (tabVulnTracker) {
      tabs.push(tabVulnTracker);
    }
    // sysMonitor
    const sysMonitor = menus.find((menu) => menu.service === "sysMonitor");
    const cardSysMonitor = card(sysMonitor, admin);
    const tabSysMonitor = tab(sysMonitor, admin);
    if (cardSysMonitor) {
      cardsVnss.push(cardSysMonitor);
      vnssAvailable = vnssAvailable || cardSysMonitor.active;
    }
    if (tabSysMonitor) {
      tabs.push(tabSysMonitor);
    }
    // l2Blocker
    const l2Blocker = menus.find((menu) => menu.service === "l2Blocker");
    const cardL2Blocker = card(l2Blocker, admin);
    const tabL2Blocker = tab(l2Blocker, admin);
    if (cardL2Blocker) {
      cardsVnss.push(cardL2Blocker);
      vnssAvailable = vnssAvailable || cardL2Blocker.active;
    }
    if (tabL2Blocker) {
      tabs.push(tabL2Blocker);
    }

    // membership
    // NOTE: membershipはnetFinderが有効な場合のみ表示する
    const isNetFinder = menus.find((menu) => menu.service === "netFinder");
    const membership = isNetFinder
      ? { service: "membership", active: isNetFinder.active }
      : undefined;
    const cardMembership = card(membership, admin);
    const tabMembership = tab(membership, admin);
    if (cardMembership) {
      cardsVnss.push(cardMembership);
      vnssAvailable = vnssAvailable || cardMembership.active;
    }
    if (tabMembership) {
      tabs.push(tabMembership);
    }
    // joint
    const joint = isNetFinder
      ? { service: "joint", active: isNetFinder.active }
      : undefined;
    const cardJoint = card(joint, admin);
    const tabJoint = tab(joint, admin);
    if (cardJoint) {
      cardsVnss.push(cardJoint);
      vnssAvailable = vnssAvailable || cardJoint.active;
    }
    if (tabJoint) {
      tabs.push(tabJoint);
    }

    if (vnssAvailable) {
      const support = { service: "support", active: true };
      const cardSupport = card(support, admin);
      const tabSupport = tab(support, admin);
      if (cardSupport) {
        cardsVnss.push(cardSupport);
      }
      if (tabSupport) {
        tabs.push(tabSupport);
      }
    }

    // Vario SSO
    const sso = menus.find((menu) => menu.service === "sso");
    const cardSso = card(sso, admin);
    const tabSso = tab(sso, admin);
    if (cardSso) {
      cardsSso.push(cardSso);
    }
    if (tabSso) {
      tabs.push(tabSso);
    }
    this.menuInfo.ssoAvailable = !!cardSso?.active;

    this.menuInfo.cardsVnss = cardsVnss;
    this.menuInfo.cardsOthers = cardsOthers;
    this.menuInfo.cardsSso = cardsSso;
    this.menuInfo.tabs = tabs;
    this.menuInfo.vnssAvailable = vnssAvailable;
  }

  apiErrors: string[] = [];

  @Mutation
  ClearApiErrors() {
    this.apiErrors = [];
  }

  @Mutation
  AddApiError(payload: { target: string; message: string }) {
    const error = "エラー発生（" + payload.target + "）：" + payload.message;
    this.apiErrors.push(error);
  }
}

export const NetFinderCommonModule = getModule(Common);
